import { render, staticRenderFns } from "./permission-view.vue?vue&type=template&id=a814880e&scoped=true"
import script from "./permission-view.vue?vue&type=script&lang=js"
export * from "./permission-view.vue?vue&type=script&lang=js"
import style0 from "./permission-view.vue?vue&type=style&index=0&id=a814880e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a814880e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a814880e')) {
      api.createRecord('a814880e', component.options)
    } else {
      api.reload('a814880e', component.options)
    }
    module.hot.accept("./permission-view.vue?vue&type=template&id=a814880e&scoped=true", function () {
      api.rerender('a814880e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/renderers/permission-view-renderer/permission-view.vue"
export default component.exports